import { styled as i } from "styled-components";
import { skeletonFadeAnimation as o } from "../../../../styles/animation.js";
import { MediaQuery as t } from "../../../../styles/variables.js";
const m = i.div`
  position: relative;
  border-radius: 16px;
  min-height: 178px;

  @media ${t.SCREEN_MD_UP} {
    min-height: 172px;
  }

  ${({ animate: e }) => o({ animate: e, disableBackground: !1 })}
`;
export {
  m as ContainerSkeletonDefault
};
